<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="draw_modal_trriger">        
        <div class="draw-modal u-window">
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="card modal-card" :class="ramdonCard()"></div>
                </div>
                <div class="card-num" v-if="actComplete"><em>X</em>1</div>
            </div>
            <div class="u-btn draw" v-if="actComplete == false" @click="draw"></div>
            <div class="u-btn submit" v-else @click="closeModal"></div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import GLOBAL from '@/assets/js/global.js';

export default {
    name : 'draw-modal',
    data : function (){
        return {
            actComplete : false,
            cid : 0,
            clsaa : 0,
        }
    },
    props : {
        draw_modal_trriger : {
            default : false
        },
        code : {
            require : true
        }
    },
    methods: {
        closeModal(){
            document.body.removeEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.$emit("modal_switch", 'draw_modal_trriger');
            this.actComplete = false;
        },
        ramdonCard(){
            var clz = Math.ceil(Math.random()*5);
            return 'card-' + clz;
        },
        draw(){
            var _v = this;
            if(!_v.code)return _v.$toast.info('请尝试其他二维码~');
            _v.$axios.post(_v.$global.ajax_url_map.draw + '?ver=' + GLOBAL.version,GLOBAL.param({
                code : _v.code
            }))
            .then(function(response){
                if(response.data.code === 0){

                    _v.actComplete = true;
                    _v.cid = response.data.data.id;//卡片id
                    _v.class = response.data.data.class;//卡片类型

                    document.querySelector('.draw-modal .card').classList.toggle('card-flip');
                    document.querySelector('.draw-modal .card').style.backgroundImage = 'url( '+ require('@/assets/images/card-card-' + _v.class + '.jpg') +' )';
                    //document.querySelector('.draw-modal .card').style.backgroundImage = require('@/assets/images/card-back.jpg');

                    _v.$emit("cardinfo_update", {
                        class : response.data.data.class,
                        cnt : 1
                    });
                }
                else{
                    _v.$toast.info(response.data.message);
                }                
            })
            .catch(function (error) {
                console.log(error);
            });

        },
    },    
}
</script>

<style>
    .draw-modal .dialog-content{
        position: relative;
        width: 5.18rem;
        height: 7.37rem;
        margin: 0 auto .55rem;
        background-image: url(~@/assets/images/modal-card.png);
    }

    .draw-modal .dialog-wrapper{
        padding: .6rem .6rem 0;
    }

    .draw-modal .u-btn.draw{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-draw.png);    
    }

    .draw-modal .u-btn.submit{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-check.png);    
    }    

    .draw-modal .u-btn.close{
        position: absolute;
        top: -.3rem;
        right: -.2rem;
    }

    .draw-modal .card{
        width: 3.65rem;
        height: 6.13rem;
        margin: 0 auto;
        transition: 0.5s ease-in-out;
        background-image: url(~@/assets/images/card-back.jpg);
        background-size: auto 100%;
        background-position: center;     
    }

    /* .draw-modal .card.card-1{
        background-image: url(~@/assets/images/card-card-1.jpg);
    }

    .draw-modal .card.card-2{
        background-image: url(~@/assets/images/card-card-2.jpg);
    }
    
    .draw-modal .card.card-3{
        background-image: url(~@/assets/images/card-card-3.jpg);
    }
    
    .draw-modal .card.card-4{
        background-image: url(~@/assets/images/card-card-4.jpg);
    }
    
    .draw-modal .card.card-5{
        background-image: url(~@/assets/images/card-card-5.jpg);
    }     */

    .draw-modal .card.card-flip {
        transform: rotateY(180deg) scaleX(-1);
        /* background-image: url(../images/card-filp.png); */
    }

    .draw-modal .card-num{
        position: absolute;
        bottom: -.4rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: .32rem;
        color: #ffc26d;
    }

    .draw-modal .card-num em{
        font-size: .28rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/drawModal.vue